/* eslint-disable no-bitwise */

export type UUID = string & {readonly __brand: unique symbol};

export function isUUID(value: string): value is UUID {
  return value.length === 36;
}

export function toUUID(value: string): UUID {
  if (!isUUID(value)) {
    throw new Error(`Invalid UUID: ${value}`);
  }
  return value as UUID;
}

export function toUUIDOrNull(value?: string | null): UUID | null {
  if (!value) {
    return null;
  }
  return toUUID(value);
}

// Produces a deterministic UUID from a short numeric suffix, for use in test fixtures.
// e.g. makeUUID(101) → '00000000-0000-0000-0000-000000000101'
export function makeUUID(n: number): UUID {
  return toUUID(`00000000-0000-0000-0000-${String(n).padStart(12, '0')}`);
}

export function generateUUIDv4(): UUID {
  // Generate RFC4122 version 4 UUID
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (crypto.getRandomValues(new Uint8Array(1))[0] & 0xf) >> 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
  return uuid as UUID;
}
